import 'twin.macro';
/* eslint-disable no-return-assign */
import React, { RefObject } from 'react';
import { useUser } from '@teetsh/app/src/containers/App/context/useUser';
import { CustomFieldDefinition, CustomFieldValue } from 'types/customField';
import { CustomFieldComponent } from './CustomFieldComponent';

interface Props {
  className?: string;
  items: CustomFieldValue[];
  customFieldDefinitions: CustomFieldDefinition[];
  onChange: (v: CustomFieldValue[]) => void;
  customFieldsInputRefs?: RefObject<HTMLInputElement[]>;
  onUpdateDefinition: (v: CustomFieldDefinition) => Promise<void>;
  onDeleteDefinition: (v: CustomFieldDefinition) => Promise<void>;
  alignText?: 'center' | 'right' | 'left';
}

export function CustomFieldsComponent(props: Props) {
  const {
    className,
    items,
    onChange,
    customFieldsInputRefs,
    customFieldDefinitions,
    onUpdateDefinition,
    onDeleteDefinition,
    alignText,
  } = props;
  const user = useUser();

  return (
    <>
      {customFieldDefinitions.map((definition, index) => {
        const ref = (customFieldsInputRefs as any)?.current
          ? el => ((customFieldsInputRefs as any).current[index] = el)
          : undefined;
        return (
          <div tw="mb-2" className={className} key={definition.id}>
            <CustomFieldComponent
              customFieldDefinition={definition}
              onChange={updatedField => {
                if (items.find(i => i.id === updatedField.id)) {
                  return onChange(
                    items.map(originalField =>
                      originalField.id === updatedField.id
                        ? updatedField
                        : originalField,
                    ),
                  );
                }
                return onChange([...items, updatedField]);
              }}
              alignText={alignText}
              inputRef={ref}
              customField={items.find(f => f.id === definition.id)}
              onDelete={() =>
                onChange(items.filter(i => i.id !== definition.id))
              }
              onUpdateDefinition={onUpdateDefinition}
              onDeleteDefinition={onDeleteDefinition}
              enableEdit={!user.guestMode?.enabled}
            />
          </div>
        );
      })}
    </>
  );
}
